import React from 'react';
import {Trans} from 'react-i18next';
import {TypedTranslation} from '../../../../../i18n';
import '../../../../../incase-domain/components/modals/errorModal/styles/errorModalContent.scss';

interface InvalidLinkModalContentProps {
    title: string;
    description: TypedTranslation;
    params: string[];
}

function BoldList({items}: {items: string[]}): JSX.Element {
    return (
        <>
            {items.map((item, index) => (
                <React.Fragment key={item}>
                    {index > 0 && ', '}
                    <strong>{item}</strong>
                </React.Fragment>
            ))}
        </>
    );
}

function InvalidLinkModalContent({title, description, params}: InvalidLinkModalContentProps): JSX.Element {
    return (
        <div className="c-errorModalContent">
            <div className="c-errorModalContent__title">{title}</div>
            <div className="c-errorModalContent__description">
                <Trans i18nKey={description} components={{params: <BoldList items={params} />}} />
            </div>
        </div>
    );
}

export default InvalidLinkModalContent;
